export const T = {
  en_GB: {
    delete: "Delete",
    edit: "Edit",
    productName: "Product Name",
    documents: "Documents",
    actions: "Actions",
    noProducts: "No products yet.",
    noProductsMatch: "No products match your search",
    noDocumentTypes: "No document types configured for this collection.",
    notSet: "—",
  },
  nb_NO: {
    delete: "Slett",
    edit: "Rediger",
    productName: "Produktnavn",
    documents: "Dokumenter",
    actions: "Handlinger",
    noProducts: "Ingen produkter ennå.",
    noProductsMatch: "Ingen produkter samsvarer med søket",
    noDocumentTypes: "Ingen dokumenttyper konfigurert for denne samlingen.",
    notSet: "—",
  },
} as const;
